import { render, staticRenderFns } from "./TheBrandsCarousel.vue?vue&type=template&id=5811fab6&scoped=true&"
import script from "./TheBrandsCarousel.vue?vue&type=script&lang=js&"
export * from "./TheBrandsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheBrandsCarousel.vue?vue&type=style&index=0&id=5811fab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811fab6",
  null
  
)

export default component.exports